import React, { FC } from 'react'
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faInstagram, faLinkedin, faWhatsapp, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'

const icons = {
  envelope: faEnvelope,
  facebook: faFacebook,
  instagram: faInstagram,
  linkedin: faLinkedin,
  phone: faPhone,
  whatsapp: faWhatsapp,
  youtube: faYoutube
}

interface FaIconProps extends Omit<FontAwesomeIconProps, 'icon'> {
  icon: keyof typeof icons
}

export const FaIcon: FC<FaIconProps> = ({icon, ...props}) => (
  <FontAwesomeIcon icon={icons[icon]} {...props} />
)
